import ArticleLayout from "@/components/feature/ArticleLayout";
import { newArticles } from "@/mocks/articles";

export default function ComparacaoAgentesHoobuy() {
  return <ArticleLayout article={newArticles[3]} />;
}